import { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";

/***************************
 * Cookie helpers
 ***************************/
function setCookie(name, value, days = 7) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = "expires=" + date.toUTCString();
  document.cookie = `${name}=${value}; ${expires}; path=/; Secure; SameSite=Lax`;
}

function getCookie(name) {
  const cookies = document.cookie.split(";");
  const needle = name + "=";
  for (let c of cookies) {
    c = c.trim();
    if (c.startsWith(needle)) {
      return c.substring(needle.length, c.length);
    }
  }
  return null;
}

function deleteCookie(name) {
  document.cookie = `${name}=; Max-Age=0; path=/; Secure; SameSite=Lax`;
}

export default function App() {
  const [token, setToken] = useState(null);

  /***********************
   * On mount: load JWT from cookie
   ***********************/
  useEffect(() => {
    const storedToken = getCookie("jwt");
    if (storedToken) {
      try {
        const decoded = jwtDecode(storedToken);
        setToken(decoded);
      } catch (e) {
        deleteCookie("jwt");
      }
    }
  }, []);

  if (!token) {
    return <LoginPage setToken={setToken} />;
  }

  return <WelcomePage token={token} setToken={setToken} />;
}

/***********************
 * Login page
 ***********************/
function LoginPage({ setToken }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);

  const login = async () => {
    setError(null);
    try {
      const res = await fetch("/api/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password }),
      });
      const data = await res.json();
      if (data.token) {
        setCookie("jwt", data.token);
        setToken(jwtDecode(data.token));
      } else {
        setError("Invalid credentials");
      }
    } catch (err) {
      setError("Network error");
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen gap-4 bg-gray-50">
      <div className="w-full max-w-xs p-6 bg-white rounded-2xl shadow">
        <h2 className="mb-4 text-xl font-semibold text-center">Login</h2>
        <input
          className="w-full px-3 py-2 mb-3 border rounded-lg focus:outline-none focus:ring"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          className="w-full px-3 py-2 mb-3 border rounded-lg focus:outline-none focus:ring"
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        {error && <p className="mb-2 text-sm text-red-600">{error}</p>}
        <button
          className="w-full py-2 font-semibold text-white rounded-lg bg-blue-600 hover:bg-blue-700"
          onClick={login}
        >
          Login
        </button>
      </div>
    </div>
  );
}

/***********************
 * Welcome page
 ***********************/
function WelcomePage({ token, setToken }) {
  console.log(token)
  const logout = () => {
    deleteCookie("jwt");
    setToken(null);
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen gap-6 bg-gray-50">
      <div className="p-8 text-center bg-white rounded-2xl shadow">
        <h1 className="mb-4 text-2xl font-bold">Welcome, {token.username}!</h1>
        <a
          href="/novnc/vnc.html?autoconnect=true&password=novnc"
          className="inline-block px-4 py-2 mb-4 font-semibold text-white rounded-lg bg-green-600 hover:bg-green-700"
        >
          Open noVNC
        </a>
        <button
          onClick={logout}
          className="inline-block px-4 py-2 font-semibold text-white rounded-lg bg-red-600 hover:bg-red-700"
        >
          Logout
        </button>
      </div>
    </div>
  );
}

